"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _d3TimeFormat = require("d3-time-format");
var _d3Format = require("d3-format");
var _Chart = require("../../Chart");
var _accessProperty = _interopRequireDefault(require("../../../utils/accessProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Shared logic for deriving props for Chart components. Helps to support a flexible
 * external API, while keeping the type of props passed into presentational components
 * consistent.
 */

var getAxisTooltipFormat = function getAxisTooltipFormat(tooltipFormat, _ref) {
  var isCategorical = _ref.isCategorical,
    isTimeSeries = _ref.isTimeSeries;
  if (typeof tooltipFormat === 'function') {
    return tooltipFormat;
  }
  if (isTimeSeries) {
    return tooltipFormat ? (0, _d3TimeFormat.timeFormat)(tooltipFormat) : (0, _d3TimeFormat.timeFormat)(_Chart.defaultDateSpecifier);
  }
  if (isCategorical && !isTimeSeries) {
    return function (x) {
      return x;
    };
  }
  return tooltipFormat ? (0, _d3Format.format)(tooltipFormat) : _Chart.defaultNumberFormatter;
};
var deriveAxis = function deriveAxis(axis) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-line
  var isTimeSeries = options.isTimeSeries,
    isCategorical = options.isCategorical;
  var normalizedAxis = typeof axis === 'string' || typeof axis === 'function' ? {
    value: axis,
    tooltipFormat: null
  } : axis;
  var accessor = function accessor(datum) {
    return (0, _accessProperty["default"])(datum, normalizedAxis.value);
  };
  var baseAxis = {
    label: ''
  };
  var derivedAxis = {
    value: accessor,
    /** We compose the tooltip formatter with xAxis.value accessor. */
    tooltipFormat: function tooltipFormat(datum) {
      return getAxisTooltipFormat(normalizedAxis.tooltipFormat, {
        isCategorical: isCategorical,
        isTimeSeries: isTimeSeries
      })(accessor(datum));
    }
  };
  return _objectSpread(_objectSpread(_objectSpread({}, baseAxis), normalizedAxis), derivedAxis);
};
var normalizeSeries = function normalizeSeries(series) {
  if (Array.isArray(series)) {
    return series.map(function (s) {
      return {
        label: s.label,
        color: s.color,
        value: function value(datum) {
          return (0, _accessProperty["default"])(datum, s.value);
        }
      };
    });
  }
  return [];
};

/**
 * When no series is provided, we derive it from the yAxis. If a series is provided
 * then we compose functions from the yAxis with functions from the series. This allows
 * the user to define the selection logic for series separately from the selection logic
 * for metrics.
 */
var deriveSeries = function deriveSeries(series, yAxis) {
  var normalizedSeries = normalizeSeries(series);
  /**
   * If no series is defined, we create a single series from the yAxis object.
   */
  if (normalizedSeries.length) {
    return normalizedSeries.map(function (s, index) {
      return {
        label: s.label || "Series #".concat(index),
        color: s.color,
        value: function value(datum) {
          return yAxis.value(s.value(datum));
        },
        tooltipFormat: function tooltipFormat(datum) {
          return yAxis.tooltipFormat(s.value(datum));
        }
      };
    });
  }
  return [{
    label: yAxis.label,
    color: yAxis.color,
    value: yAxis.value,
    tooltipFormat: yAxis.tooltipFormat
  }];
};
var calculateTickValues = function calculateTickValues(_ref2) {
  var data = _ref2.data,
    isTimeSeries = _ref2.isTimeSeries,
    isCategorical = _ref2.isCategorical,
    xValue = _ref2.xValue;
  if (!isTimeSeries && isCategorical) {
    return data.map(xValue);
  }
  return null;
};

/**
 * Calculates a tickDivisor which is used to hide all axis labels, whose position
 * index is not divided evenly by the tickDivisor.
 */

var calculateTickDivisor = function calculateTickDivisor(_ref3) {
  var data = _ref3.data,
    isCategorical = _ref3.isCategorical,
    isTimeSeries = _ref3.isTimeSeries,
    width = _ref3.width;
  /**
   * Naive heuristic for computing number of tick values that will look good
   * on an axis, may need to be improved in future.
   */
  var tickCount = Math.floor(+width / 80);
  var tickDivisor = Math.floor(data.length / tickCount);
  // return tickDivisor;
  return isCategorical && !isTimeSeries && tickDivisor !== 0 ? tickDivisor : 1;
};
var validateProps = function validateProps(props) {
  var componentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
  var series = props.series,
    yAxis = props.yAxis;
  if (!series && !yAxis) {
    console.warn("".concat(componentName, ": Must provide a valid yAxis OR a valid series as props")); // eslint-disable-line
    return false;
  }
  return true;
};
var _default = exports["default"] = {
  calculateTickDivisor: calculateTickDivisor,
  calculateTickValues: calculateTickValues,
  deriveAxis: deriveAxis,
  deriveSeries: deriveSeries,
  validateProps: validateProps
};
//# sourceMappingURL=CalculateProps.js.map